export default __webpack_public_path__ + "images/AutumnCompanyBackground.web.png";